import { render, staticRenderFns } from "./question.vue?vue&type=template&id=39e27c7a&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=39e27c7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e27c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e27c7a')) {
      api.createRecord('39e27c7a', component.options)
    } else {
      api.reload('39e27c7a', component.options)
    }
    module.hot.accept("./question.vue?vue&type=template&id=39e27c7a&scoped=true&", function () {
      api.rerender('39e27c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonAnswer/question.vue"
export default component.exports